import {Badge, HStack, Icon, Text, VStack} from "@chakra-ui/react";
import {HiOutlineGlobeAlt, HiOutlinePencil} from "react-icons/hi2";

const methodColorMap = {
    GET: "blue",
    POST: "green",
    PUT: "orange",
    DELETE: "red",
}

const EndpointListItem = ({endpoint, onEdit}) => {
    return (
        <HStack
            p={6}
            borderWidth={1}
            borderColor={'border.secondary'}
            w={'full'}
            borderRadius={12}
            bg={'bg.card'}
            columnGap={6}
            cursor={'pointer'}
            _hover={{bg: 'bg.highlight'}}
            transition="background 0.2s ease-in-out"
            onClick={() => onEdit(endpoint)}
        >
            <Icon fontSize={46} strokeWidth={0.75} color={'white'}>
                <HiOutlineGlobeAlt/>
            </Icon>
            <VStack alignItems={'flex-start'} gap={1} flex={1}>
                <HStack gap={2} alignItems={'center'}>
                    <Badge colorPalette={methodColorMap[endpoint.method] ?? 'gray'} variant={'subtle'} fontSize={11}>
                        {endpoint.method}
                    </Badge>
                    <Text color={'white'} fontWeight={500}>{endpoint.name}</Text>
                    {endpoint.tag && (
                        <Badge variant={'outline'} colorPalette={'purple'} fontSize={11}>{endpoint.tag}</Badge>
                    )}
                    {endpoint.provider && (
                        <Badge variant={'subtle'} colorPalette={'cyan'} fontSize={11}>{endpoint.provider}</Badge>
                    )}
                </HStack>
                <Text color={'text.grey'} fontSize={13}>{endpoint.url}</Text>
                {endpoint.description && (
                    <Text color={'text.grey'} fontSize={12}>{endpoint.description}</Text>
                )}
                {endpoint.params?.length > 0 && (
                    <Text color={'text.grey'} fontSize={12}>
                        {endpoint.params.length} parameter{endpoint.params.length !== 1 ? 's' : ''}
                    </Text>
                )}
            </VStack>
            <Icon fontSize={22} strokeWidth={1.5} color={'text.grey'} _hover={{color: 'white'}} transition="color 0.2s">
                <HiOutlinePencil/>
            </Icon>
        </HStack>
    )
}

export default EndpointListItem;
